"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotationAction = exports.ChargePointStatus = exports.ChargeCardStatus = exports.ProductColor = exports.ChargePointType = exports.ProductGroup = exports.cardType = exports.productType3 = exports.productType2 = exports.status = exports.productType = exports.action3 = exports.type2 = exports.actionID = exports.currentSegmentType = exports.requestedSegmentType = exports.customer_scenario = exports.salutation = exports.mount_type = exports.charge_card_type = exports.proposition_id = exports.product_type = exports.card_type = exports.gender = exports.mountType = exports.color = exports.type = exports.electricity_mains_value = exports.charging_station_name = exports.color_charging_station = exports.pole_or_wall_installation = exports.reimbursementApplicable = exports.action2 = exports.action = exports.channel = exports.contact_log_type = void 0;
/**
 * The type of contactlog. Use contact_log if there has been interaction with the customer, and service_request if there was no interaction between Essent/Energiedirect and the customer.
 */
exports.contact_log_type = {
    CONTACT_LOG: 'contact_log',
    SERVICE_REQUEST: 'service_request'
};
/**
 * The channel to which how the contact has taken place
 */
exports.channel = {
    TELEPHONE: 'telephone',
    BRIEF: 'brief',
    RETURN_POST: 'returnpost',
    FAX: 'fax',
    FORMS: 'forms',
    MIJN_ESSENT: 'mijnessent_nl',
    MAIL_WEBFORM: 'e-mail_webform',
    VISIT: 'visit',
    EXTERN: 'extern',
    OPEN_ENV_WEBFORM: 'open_env_webform',
    CLOSED_ENV_WEBFORM: 'closed_env_webform',
    SOCIAL_MEDIA: 'social_media',
    INTERNAL_ADVICE: 'intern_advice',
    SMS: 'sms',
    CHAT: 'chat',
    TELEFONIEBOT: 'telefoniebot',
    CHATBOT: 'chatbot'
};
/**
 * what BPM action to take
 */
exports.action = {
    SUBMIT_QUOTATION_APPROVAL_DATA: 'submit_quotation_approval_data',
    SUBMIT_QUOTATION_REJECTED_DATA: 'submit_quotation_rejected_data',
    SUBMIT_DRIVER_APPROVAL: 'submit_driver_approval',
    QUOTATION_REJECTED_BY_DRIVER: 'quotation_rejected_by_driver'
};
/**
 * the case action type
 */
exports.action2 = {
    CallbackCustomer: 'CALLBACK_CUSTOMER',
    ReviewQuestionnaire: 'REVIEW_QUESTIONNAIRE',
    UploadQuotation: 'UPLOAD_QUOTATION',
    ActivateChargingStation: 'ACTIVATE_CHARGING_STATION',
    ActivateChargeCard: 'ACTIVATE_CHARGE_CARD'
};
/**
 * reimbursement applicable
 */
exports.reimbursementApplicable = {
    TRUE: 'true',
    FALSE: 'false'
};
/**
 * Indicates whether the customer wants a pole or wall installation
 */
exports.pole_or_wall_installation = {
    Pole: 'Paalmontage',
    Wall: 'Wandmontage'
};
/**
 * Indicates the color of the charging station
 */
exports.color_charging_station = {
    White: 'Wit',
    Anthracite: 'Antraciet'
};
/**
 * Indicates name of the charging station type
 */
exports.charging_station_name = {
    SLine: 's-line',
    ProLine: 'pro-line'
};
/**
 * Indicates the type of connection of the household
 */
exports.electricity_mains_value = {
    _1X25: '1x25',
    _2X25: '2x25',
    _3X25: '3x25',
    _4X25: '4x25',
    _1X25A: '1x25A',
    _2X25A: '2x25A',
    _3X25A: '3x25A',
    _4X25A: '4x25A'
};
/**
 * The type of the charge station
 */
exports.type = {
    SLine: 's-line',
    ProLine: 'pro-line'
};
/**
 * Charging station color
 */
exports.color = {
    White: 'Wit',
    Anthracite: 'Antraciet'
};
/**
 * Charging station mount type
 */
exports.mountType = {
    Pole: 'Paalmontage',
    Wall: 'Wandmontage'
};
/**
 * Gender of the customer to allow us to define how to address the customer
 */
exports.gender = {
    MALE: 'male',
    FEMALE: 'female',
    OTHER: 'other'
};
/**
 * The type of the charge card
 */
exports.card_type = {
    ChargeCard: 'ChargeCard',
    KeyFob: 'Druppel'
};
/**
 * Product type
 */
exports.product_type = {
    ChargeCard: 'charge-card',
    ChargingStation: 'charge-station'
};
/**
 * The selected proposition
 */
exports.proposition_id = {
    CHARGING_STATION: 'particulier-laden',
    CHARGE_CARD: 'particulier-laadpas',
    CHARGING_STATION_REIMBURSEMENT: 'reimbursement-laden'
};
/**
 * The charge card type
 */
exports.charge_card_type = {
    ChargeCard: 'ChargeCard',
    KeyFob: 'Druppel'
};
/**
 * The mount type of the charging station
 */
exports.mount_type = {
    Pole: 'Paalmontage',
    Wall: 'Wandmontage'
};
/**
 * Gender of the customer to allow us to define how to address the customer
 */
exports.salutation = {
    MALE: 'male',
    FEMALE: 'female',
    OTHER: 'other'
};
/**
 * The customer scenario
 */
exports.customer_scenario = {
    New: 'NEW_CUSTOMER',
    ExistingConsumer: 'EXISTING_CONSUMER',
    ExistingConsumerWithCard: 'EXISTING_CONSUMER_WITH_CARD',
    ExistingSoho: 'EXISTING_SOHO'
};
/**
 * Requested segment
 */
exports.requestedSegmentType = {
    HOUSEHOLD: 'household',
    SMALL_OFFICE_HOME_OFFICE: 'small_office_home_office'
};
/**
 * Requested segment
 */
exports.currentSegmentType = {
    HOUSEHOLD: 'household',
    SMALL_OFFICE_HOME_OFFICE: 'small_office_home_office'
};
/**
 * what action to execute
 */
exports.actionID = {
    ProcessCustomerConfirmation: 'PROCESS_CUSTOMER_CONFIRMATION',
    ProcessCustomerCreation: 'PROCESS_CUSTOMER_CREATION',
    AbortStepFunction: 'ABORT_STEP_FUNCTION',
    SendEmail: 'SEND_EMAIL'
};
/**
 * Name of the photo
 */
exports.type2 = {
    SmartMeter: 'smartMeter',
    FuseBox: 'fusebox',
    GroupBox: 'groupbox',
    InstallationSite: 'installationSite',
    CrawlSpace: 'crawlSpace',
    DiggingGroundType: 'digginggroundtype',
    DiggingGroundType2: 'digginggroundtype2'
};
/**
 * what BPM action to take
 */
exports.action3 = {
    SAVE_QUESTIONNAIRE_DATA: 'save_questionnaire_data',
    SUBMIT_QUOTATION_TO_DATACOLLECTION: 'submit_quotation_to_datacollection',
    SUBMIT_QUOTATION_DATA: 'submit_quotation_data',
    SAVE_QUOTATION_APPROVAL_DATA: 'save_quotation_approval_data',
    SAVE_QUOTATION_DATA: 'save_quotation_data',
    SUBMIT_LEASE_QUOTATION: 'submit_lease_quotation',
    SAVE_LEASE_APPROVAL: 'save_lease_approval',
    SAVE_DRIVER_APPROVAL: 'save_driver_approval',
    SUBMIT_DRIVER_QUOTATION: 'submit_driver_quotation',
    SAVE_DRIVER_QUOTATION: 'save_driver_quotation'
};
exports.productType = {
    CHARGE_CARD: 'ChargeCard'
};
exports.status = {
    ACTIVE: 'Active',
    BLOCKED: 'Blocked',
    WAIT_FOR_OCPI_ACTIVATION: 'WaitForOcpiActivation',
    INACTIVE: 'Inactive'
};
exports.productType2 = {
    CHARGE_POINT: 'ChargePoint'
};
exports.productType3 = {
    CHARGE_CARD: 'charge-card',
    CHARGE_STATION: 'charge-station'
};
exports.cardType = {
    CHARGE_CARD: 'ChargeCard',
    DRUPPEL: 'Druppel'
};
exports.ProductGroup = {
    CHARGING_STATION: 'charging-station'
};
exports.ChargePointType = {
    SLine: 'sline',
    ProLine: 'proline'
};
exports.ProductColor = {
    Wit: 'wit',
    Antraciet: 'antraciet'
};
/**
 * Card status
 */
exports.ChargeCardStatus = {
    ACTIVE: 'Active',
    BLOCKED: 'Blocked',
    WAIT_FOR_OCPI_ACTIVATION: 'WaitForOcpiActivation',
    INACTIVE: 'Inactive'
};
exports.ChargePointStatus = {
    AVAILABLE: 'Available',
    PREPARING: 'Preparing',
    CHARGING: 'Charging',
    SUSPENDED_EVSE: 'SuspendedEVSE',
    SUSPENDED_EV: 'SuspendedEV',
    FINISHING: 'Finishing',
    RESERVED: 'Reserved',
    UNAVAILABLE: 'Unavailable',
    FAULTED: 'Faulted',
    UNKNOWN: 'Unknown'
};
exports.QuotationAction = {
    Approve: 'approve',
    Reject: 'reject'
};
